export const disclaimerSearch1 = `
  The information is compiled from publicly available online information
  obtained from local municipal offices, agencies, and departments, and is
  not comprehensive. Liberty Connect, LLC assumes no liability for any
  errors, omissions, or discrepancies. For a comprehensive title search, we
  recommend ordering a complete title search through a licensed title
  company.`;

export const disclaimerSearch2 = `
  The services are provided “as is” and Liberty Connect, LLC makes no representation or
  warranty of any kind, either express or implied, including without
  limitation any warranties of merchantability or fitness for any
  particular purpose.`;

export const disclaimerResources = `
  Links to other websites and references to other resources are provided
  solely for the convenience of the user and do not constitute an
  endorsement or recommendation. Liberty Connect, LLC assumes no liability
  to any person or entity for the services provided by any of the
  providers listed herein.`;
export const disclaimerExpertCourses = `
  This expert course is intended for informational purposes only and does
  not constitute professional advice. While delivered by experienced
  individuals in the field and certified by The Department of State,
  Bureau of Educational Standards to provide this course, the content
  should not be relied upon as a substitute for consulting with a
  qualified professional as to your specific situation.`;
export const disclaimerSocialEvents = `
  By attending this social event, you acknowledge that you participate at
  your own risk and agree to hold the organizers, venue, and any
  associated individuals harmless from any liability arising from your
  participation, including personal injury, property damage, or any
  unforeseen circumstances.`;
export const disclaimerMembership = (
  <>
    <p>
      By signing up for a membership on Liberty Connect, LLC, you agree to the
      following terms and conditions:
    </p>
    <ul>
      <li>
        <strong>Eligibility:</strong> You must be at least 18 years old and
        legally able to form binding contracts in your jurisdiction to become a
        member of Liberty Connect, LLC.
      </li>
      <li>
        <strong>Account Information:</strong> You are responsible for
        maintaining the confidentiality of your login credentials and for all
        activities that occur under your account.
      </li>
      <li>
        <strong>Content and Services:</strong> Liberty Connect, LLC provides
        access to various content, services, and features. We do not guarantee
        the accuracy, completeness, or reliability of any content or service
        provided.
      </li>
      <li>
        <strong>User Conduct:</strong> You agree to use the website in
        compliance with applicable laws and not to engage in any activity that
        could harm, disrupt, or negatively impact the website, its services, or
        other members.
      </li>
      <li>
        <strong>Modifications:</strong> Liberty Connect, LLC reserves the right
        to modify or discontinue any service or feature, and to update the terms
        and conditions of membership at any time. You will be notified of such
        changes and should review them regularly.
      </li>
      <li>
        <strong>Limitation of Liability:</strong> Liberty Connect, LLC is not
        liable for any damages arising from the use or inability to use the
        website, its services, or any content provided. You use the website at
        your own risk.
      </li>
      <li>
        <strong>Termination:</strong> We may suspend or terminate your
        membership at any time for violation of the terms or any unlawful
        behavior.
      </li>
    </ul>
  </>
);

export default function Disclaimer() {
  return (
    <div className="disclaimer-page">
      <h1>Disclaimer for Property Searches</h1>
      <p>
        {disclaimerSearch1} {disclaimerSearch2}
      </p>
      <h1>Disclaimer for Resources</h1>
      <p>{disclaimerResources}</p>
      <h1>Disclaimer as to Expert Courses</h1>
      <p>{disclaimerExpertCourses}</p>
      <h1>Disclaimer for Social Events</h1>
      <p>{disclaimerSocialEvents}</p>
      <h1>Disclaimer for Membership</h1>

      {disclaimerMembership}
    </div>
  );
}
